import React, { Component } from "react";
import { Form, FormGroup, Label, Input, Button, Alert, Container, Col } from "reactstrap";
import PlayerGrid from "./PlayerGrid";

class TeamRegistrationForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      teamName: "",
      player1: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
      },
      player2: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
      },
      errors: {},
    };
  }

  handleChange = (event, player = null) => {
    const { name, value } = event.target;
    if (player) {
      this.setState({
        [player]: {
          ...this.state[player],
          [name]: value,
        },
      });
    } else {
      this.setState({ [name]: value });
    }
  };

  validateForm = () => {
    const errors = {};
    const { teamName, player1 } = this.state;

    if (!teamName.trim()) {
      errors.teamName = "Team name is required.";
    }

    if (!player1.firstName.trim()) {
      errors.player1FirstName = "Player 1's first name is required.";
    }

    if (!player1.lastName.trim()) {
      errors.player1LastName = "Player 1's last name is required.";
    }

    if (!player1.email.trim()) {
      errors.player1Email = "Player 1's email is required.";
    }

    if (!player1.phone.trim()) {
      errors.player1Phone = "Player 1's phone number is required.";
    }

    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  handleSubmit = (event) => {
    event.preventDefault();
    if (this.validateForm()) {
      console.log("Form submitted successfully:", this.state);
    } else {
      console.log("Validation errors:", this.state.errors);
    }
  };

  render() {
    const { teamName, errors } = this.state;

    return (
      <Form onSubmit={this.handleSubmit}>
        <Container>
          <h3 className="mt-3">Team Registration</h3>
          <FormGroup row>
            <Label for="teamName" sm={1}>Team Name</Label>
            <Col sm={11}>
            <Input
              type="text"
              name="teamName"
              id="teamName"
              value={teamName}
              onChange={this.handleChange}
            />
            {errors.teamName && <Alert color="danger">{errors.teamName}</Alert>}
            </Col>
          </FormGroup>
          <PlayerGrid />
          <Button type="submit" color="primary">Submit</Button>
        </Container>
      </Form>
    );
  }
}

export default TeamRegistrationForm;
